import React, {useCallback, useEffect, useState} from 'react';
import {Formik, Form, Field} from 'formik';
import {Link} from 'react-router-dom';
import TitleMain from "../../components/Title/TitleMain";
import {useModal} from '../../contexts/ModalContext';
import {acceptCgu, saveProfileApi, saveProfileLocal} from "../../services/UserService";
import styles from "../../components/Form/Form.module.css";
import field_styles from "../../components/Field/Field.module.css";
import FieldUpload from "../../components/Field/FieldUpload";
import FieldCustom from "../../components/Field/FieldCustom";
import {useUser} from "../../contexts/UserContext";
import {getJustificatifsFiles, getJustificatifsTypes} from "../../services/FileService";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faFlag,
    faSignOut,
    faUnlock,
} from "@fortawesome/free-solid-svg-icons";
import TitleSecondary from "../../components/Title/TitleSecondary";
import BtnSave from "../../components/Button/BtnSave";
import BtnSwitch from "../../components/Button/BtnSwitch";
import stylesSwitch from "../../components/Button/BtnSwitch.module.css";
import AxiosConfig from "../../services/AxiosConfig";
import Routing from "../../services/routing";
import DateService from "../../services/DateService";
import {logout} from "../../services/AuthService";

function ProfilPage() {
    const {showModal, hideModal} = useModal();
    const {user} = useUser();
    const [inputs, setInputs] = useState([]);
    const [initialValues, setInitialValues] = useState();
    const [justificatifs, setJustificatifs] = useState([]);
    const [justificatifsTypes, setJustificatifsTypes] = useState([]);
    const [crmUserOptin, setCrmUserOptin] = useState([]);

    const handleSuccess = (children = "Succès") => {
        showModal('success', {children: children, timeout: 4000});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 4000});
    };

    useEffect(() => {
        if (!user) return;
        const newInputs = [
            {type: 'text', name: 'nom', label: 'Nom', value: user.nom},
            {type: 'text', name: 'prenom', label: 'Prénom', value: user.prenom},
            {type: 'date', name: 'birth_date', label: 'Date de naissance', value: user.date_naissance ? DateService.formatDateWithoutTime(user.date_naissance) : ''},
            {type: 'email', name: 'email', label: 'Email', value: user.email},
            {type: 'text', name: 'mobile', label: 'Mobile', value: user.tel_mobile ?? ''},
            // { type: 'text', name: 'roles', label: 'Role (MAQUETTE): ROLE_USER  ROLE_COACH  ROLE_REFERENT', value: user.roles[0]}
        ];

        setInputs(newInputs);

        const newInitialValues = newInputs.reduce((acc, input) => ({
            ...acc,
            [input.name]: input.value,
        }), {});

        setInitialValues(newInitialValues);

        /*
        getJustificatifsTypes().then(types => {
            setJustificatifsTypes(types);
        });

        const fetchJustificatifs = async () => {
            try {
                const justif = await getJustificatifsFiles();
                setJustificatifs(justif);
            } catch (error) {
                console.error('Erreur lors de la récupération des justificatifs:', error);
            }
        };

        fetchJustificatifs();
         */

        const fetchJustificatifsTypes = async () => {
            try {
                const response = await getJustificatifsTypes();
                setJustificatifsTypes(response);
            } catch (error) {
                console.error('Erreur lors de la récupération des justificatifs types:', error);
            }
        };

        const fetchJustificatifs = async () => {
            try {
                const response = await getJustificatifsFiles();
                setJustificatifs(response);
            } catch (error) {
                console.error('Erreur lors de la récupération des justificatifs:', error);
            }
        };

        const fetchCrmUserOptin = async () => {
            try {
                const response = await AxiosConfig.get(`/crm/user_optin`);
                setCrmUserOptin(response.data.myCrmUserOptin);
            } catch (error) {
                console.error('Erreur lors de la récupération des crm optin :', error);
            }
        };

        fetchJustificatifsTypes();
        fetchJustificatifs();
        if (user.roles.includes("ROLE_USER") || user.roles.includes("ROLE_REFERENT")) {
            fetchCrmUserOptin();
        }
    }, [user]);

    const handleSubmit = async (values, {setSubmitting, setFieldError}) => {
        try {
            const saveProfile = process.env.REACT_APP_MODE === 'maquette' ? saveProfileLocal : saveProfileApi;
            const response = await saveProfile(values);
            if (response.success) {
                handleSuccess(response.msg);
            } else {
                handleError(response.msg);
                setFieldError(response.key, response.msg);
            }
        } catch (error) {
            handleError("Une erreur est survenue : " + error.message);
            console.error(error);
        }
        setSubmitting(false);
    };


    const renderedFieldUploads = justificatifsTypes.length > 0 ? justificatifsTypes.map(justType => {
        const justificatif = justificatifs.find(just => {
            return just.justificatifType && just.justificatifType.justId === justType.justId;
        });

        return (
            <FieldUpload
                key={justType.justId}
                label={justType.justLabel}
                name={`type${justType.justId}_file`}
                value={justificatif}
                data={{
                    justificatifType: justType.justId,
                    justificatifObligatoire: justType.justObligatoire,
                    justificatifActif: justType.justActif
                }}
                titleExclamation={"Obligatoire"}
            />
        );
    }) : <span style={{ fontSize: "var(--fs-secondary)", fontStyle: "italic" }}>Pas de document à afficher</span>;



    const putCrmOptin = async ({target, value}) => {

        const response = await AxiosConfig.post(`/crm/user_optin?t=${target}&v=${value}`, {
            value: value
        });
        if (response.data.success) {
            handleSuccess(response.data.msg);
            crmUserOptin[target] = response.data.value;
        } else {
            handleError(response.data.msg);
        }
    }

    return (
        <div className="content">
            <TitleMain text="VOTRE PROFIL"/>

            {initialValues &&
                <Formik initialValues={initialValues} onSubmit={handleSubmit}>
                    {(formik, isSubmitting) => (
                        <Form className={styles.form}>

                            <div className={styles.formProfil}>
                                {inputs.map(({type, name, label}, index) => (
                                    <FieldCustom name={name} label={label} type={type} key={index}/>
                                ))}
                            </div>

                            <BtnSave isSubmitting={isSubmitting}/>
                        </Form>
                    )}
                </Formik>
            }


            {!user.cgu && (
                <div style={{
                padding: "4px 0 16px 0",
                marginBottom: "24px",
                marginTop: "24px",
                borderTop: "1px solid #e0e0e0",
            }}>
                <TitleSecondary text={"CGU"}/>

                <button
                    name={"cgu"}
                    onClick={async (e) => {
                        const rez = await acceptCgu({
                            value: !user.cgu
                        });

                        window.location.reload();
                    }}
                    className={"btn btn_danger"}
                >
                    Accepter les CGU
                </button>
            </div>
            )}


            <div style={{
                padding: "4px 0 16px 0",
                marginBottom: "24px",
                marginTop: "24px",
                borderBottom: "1px solid #e0e0e0",
                borderTop: "1px solid #e0e0e0",
            }}>
                <div className={field_styles.fieldUploadContainer}>
                    <TitleSecondary text={"Documents"}/>
                    {renderedFieldUploads}
                </div>
            </div>

            {(user.roles.includes("ROLE_USER") || user.roles.includes("ROLE_REFERENT")) &&
                <div style={{
                    padding: "4px 0 16px 0",
                    marginBottom: "24px",
                    marginTop: "24px",
                    borderBottom: "1px solid #e0e0e0",
                    borderTop: "1px solid #e0e0e0",
                }}>
                    <TitleSecondary text={"Notifications"}/>
                    {crmUserOptin &&
                        <>
                            <div style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "16px",
                                margin: "16px"
                            }}>
                                <div>
                                <span style={{
                                    fontSize: "0.9rem"
                                }}>Informations sur vos activités en entreprise </span>
                                    <span style={{
                                        fontStyle: "italic",
                                        fontSize: "0.9rem",
                                        color: "#333"
                                    }}>(nouvelles activités, créneaux de séances disponibles, changements de planning) </span>
                                </div>

                                <div className={styles.blocNotif} style={{flexDirection: "column"}}>
                                    <span>SMS</span>
                                    <BtnSwitch name={"crm_optin_sms_cours"}
                                               active={crmUserOptin.cours_sms ?? true}
                                               activeLabel={"Activé"}
                                               inactiveLabel={"Inactif"}
                                               onToggle={(e) => putCrmOptin({
                                                   "target": "cours_sms",
                                                   value: !crmUserOptin.cours_sms
                                               })}
                                               classNames={`${stylesSwitch.sliderCard} ${stylesSwitch.sliderCardDark}`}/>
                                </div>

                                <div className={styles.blocNotif} style={{flexDirection: "column"}}>
                                    <span>Mail</span>
                                    <BtnSwitch name={"crm_optin_email_cours"}
                                               active={crmUserOptin.cours_email ?? true}
                                               activeLabel={"Activé"}
                                               inactiveLabel={"Inactif"}
                                               onToggle={(e) => putCrmOptin({
                                                   "target": "cours_email",
                                                   value: !crmUserOptin.cours_email
                                               })}
                                               classNames={`${stylesSwitch.sliderCard} ${stylesSwitch.sliderCardDark}`}/>
                                </div>
                            </div>

                            <div style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "16px",
                                margin: "16px"
                            }}>
                                <div>
                                <span style={{
                                    fontSize: "0.9rem"
                                }}>Suivi de vos séances personnelles </span>
                                    <span style={{
                                        fontStyle: "italic",
                                        fontSize: "0.9rem",
                                        color: "#333"
                                    }}>(confirmation d’inscription, rappel de séance à venir, messages de votre coach, annulation de séance, notation de vos séances) </span>

                                </div>
                                <div className={styles.blocNotif} style={{flexDirection: "column"}}>
                                    <span>SMS</span>
                                    <BtnSwitch name={"crm_optin_sms_relances"}
                                               active={crmUserOptin.relance_sms ?? true}
                                               activeLabel={"Activé"}
                                               inactiveLabel={"Inactif"}
                                               onToggle={(e) => putCrmOptin({
                                                   "target": "relance_sms",
                                                   value: !crmUserOptin.relance_sms
                                               })}
                                               classNames={`${stylesSwitch.sliderCard} ${stylesSwitch.sliderCardDark}`}/>
                                </div>

                                <div className={styles.blocNotif} style={{flexDirection: "column"}}>
                                    <span>Mail</span>
                                    <BtnSwitch name={"crm_optin_email_relances"}
                                               active={crmUserOptin.relance_email ?? true}
                                               activeLabel={"Activé"}
                                               inactiveLabel={"Inactif"}
                                               onToggle={(e) => putCrmOptin({
                                                   "target": "relance_email",
                                                   value: !crmUserOptin.relance_email
                                               })}
                                               classNames={`${stylesSwitch.sliderCard} ${stylesSwitch.sliderCardDark}`}/>
                                </div>
                            </div>
                        </>}
                </div>}

            <Link to={Routing.routes.passwordReset} className={"floatLink"}>
                <FontAwesomeIcon icon={faUnlock} style={{marginRight: "4px"}}/>
                Modifier mon mot de passe
            </Link>

            {
                (user.roles.includes("ROLE_USER") || user.roles.includes("ROLE_REFERENT")) && (
                    <Link to={Routing.routes.reportsMe} className={"floatLink"}>
                        <FontAwesomeIcon icon={faFlag} style={{marginRight: "4px"}}/>
                        Voir mes remontées
                    </Link>
                )
            }

            <button onClick={logout} className={"btn btn_logout"}>
                <FontAwesomeIcon icon={faSignOut}/>
                Se déconnecter
            </button>
        </div>
    );
}

export default ProfilPage;
